import { render, staticRenderFns } from "./SalaryAdvanceRelease.vue?vue&type=template&id=9abd5588&"
import script from "./SalaryAdvanceRelease.vue?vue&type=script&lang=js&"
export * from "./SalaryAdvanceRelease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports